module.exports = __webpack_public_path__ + "4a01952eb5a816c1b5d07497ccc69358.svg";